import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { GoSearch } from "react-icons/go";
import {
  AiOutlinePlus,
  AiFillCheckCircle,
  AiFillCloseCircle,
} from "react-icons/ai";
import { BiEditAlt, BiSolidCheckSquare, BiSolidXSquare } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { RiCheckboxCircleFill, RiCloseCircleFill } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import { FaUserTie, FaUsers } from "react-icons/fa";

import Confirm from "../assets/img/confirm.png";

// import PhoneInput from "react-phone-input-2";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";

import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography,
} from "@material-tailwind/react";
import { toast } from "react-toastify";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";

import useEncryption from "../useEncryption/useEncryption";

import UserTodo from "../TodoList/TodoListUser";
import AdminTodo from "../TodoList/TodoListAdmin";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text?.slice(0, 20) : text}
      <span onClick={toggleReadMore} className="text-[#22345C] cursor-pointer ">
        {isReadMore ? "...read more" : " show less"}
      </span>
    </p>
  );
};

const TodoList = () => {
  const [searchUser, setSearchUser] = useState("");

  // Successfully Popup
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (showForm) {
      const timer = setTimeout(() => {
        setShowForm(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showForm]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const [userRole, setUserRole] = useState(""); // Role wise manage
  useEffect(() => {
    const userRole = localStorage.getItem("Role");
    if (userRole) {
      setUserRole(userRole);
    }
  }, []);

  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Task</h1>
          </div>
          <div className="relative">
            <input
              className="shadow-md pl-10  rounded-lg lg:w-96 text-[#9F9F9F] text-[16px] py-2 px-3  focus:outline-none"
              id="username"
              type="text"
              placeholder="Search"
              autoComplete="off"
              onChange={(e) => setSearchUser(e.target.value)}
            />

            <div className="absolute left-0 inset-y-0 flex py-2 ">
              <GoSearch size={20} className="ml-3 text-[#22345C]" />
            </div>
          </div>
        </div>

        {userRole !== "user" && (
          <div className="flex justify-center">
            <label className="themeSwitcherTwo shadow-card relative inline-flex cursor-pointer select-none items-center justify-center rounded-md bg-white p-1">
              <input
                type="checkbox"
                className="sr-only"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span
                className={`flex items-center space-x-[6px] rounded py-2 px-[18px] text-base font-medium ${
                  !isChecked ? "text-white bg-[#22345C]" : "text-body-color"
                }`}
              >
                <FaUserTie size={18} className="mr-2" />
                Admin
              </span>
              <span
                className={`flex items-center space-x-[6px] rounded py-2 px-[18px] text-base font-medium ${
                  isChecked ? "text-white bg-[#22345C]" : "text-body-color"
                }`}
              >
                <FaUsers size={18} className="mr-2" />
                User
              </span>
            </label>
          </div>
        )}

        {isChecked ? (
          <UserTodo searchUser={searchUser} />
        ) : (
          <AdminTodo searchUser={searchUser} />
        )}
      </div>
    </Layout>
  );
};

export default TodoList;
